import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    Button,
    ListGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { actions } from '../../../../context';
import AccountToModify from './AccountToModify';

const listHeight = '500px';

const ManageAccountsModal = ({
    partnerId,
    toggle,
    refresh,
    isOpen = false,
}) => {
    const dispatch = useDispatch();
    const [filter, setFilter] = useState('');
    const [accounts, setAccounts] = useState([]);

    const close = useCallback(() => {
        setFilter('');
        toggle();
    }, [toggle]);

    const refreshAccounts = useCallback(
        () =>
            dispatch(
                actions.accounts.getAccountsToAssignPartner(partnerId)
            ).then((res) => setAccounts(res?.data || [])),
        [dispatch, partnerId]
    );

    const toggleRefresh = useCallback(() => {
        refresh();
        refreshAccounts();
    }, [refresh, refreshAccounts]);

    const getFilteredAccount = () =>
        accounts.filter((x) =>
            x.fullName.toLowerCase().includes(filter.toLowerCase())
        );

    const filteredAccounts = () => {
        if (filter === '') return [];
        if (accounts.length <= 0) return [];
        return getFilteredAccount();
    };

    useEffect(() => {
        if (isOpen) refreshAccounts();
        // eslint-disable-next-line
    }, [dispatch, partnerId, isOpen]);

    return (
        <Modal
            className="text-light"
            style={{ minWidth: '35vw' }}
            centered
            isOpen={isOpen}
            toggle={close}>
            <ModalHeader>Manage Accounts</ModalHeader>
            <ModalBody>
                <div className="text-center mb-4">
                    <input
                        type="search"
                        placeholder="Filter accounts"
                        className="rounded p-1 w-75 text-center"
                        onChange={(e) => setFilter(e.target.value)}
                    />
                </div>
                <ListGroup
                    style={{
                        minHeight: listHeight,
                        maxHeight: listHeight,
                        overflowY: 'auto',
                    }}>
                    {accounts.length === 0 ? (
                        <div className="text-light text-center">
                            No available accounts for this partner's domain
                        </div>
                    ) : (
                        filteredAccounts().length === 0 && (
                            <div className="op-5 text-center">
                                No accounts match your search
                            </div>
                        )
                    )}

                    {filteredAccounts().map((a) => (
                        <AccountToModify
                            key={a.id}
                            partnerId={partnerId}
                            refresh={toggleRefresh}
                            accountId={a.id}
                            connectedToPartner={a.connectedToPartner}
                            firstName={a.firstName}
                            lastName={a.lastName}
                            email={a.email}
                        />
                    ))}
                </ListGroup>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" onClick={close}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ManageAccountsModal;
